import { render } from "./TableSpanTest.vue?vue&type=template&id=48e9ecdf&ts=true"
import script from "./TableSpanTest.vue?vue&type=script&lang=ts"
export * from "./TableSpanTest.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/yzh-mac/Documents/inm/git/砺成文化/word-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__